import { register, find } from '../../../../Javascript/Sysmex/Utils'

const MiniDropdown = el => {
  const componentPrefix = el.dataset.componentprefix
  const mouseoverinteraction = el.dataset.mouseoverinteraction
  const opener = find(`.${componentPrefix}opener`, el)
  const otherDropdowns = document.querySelectorAll(`.${componentPrefix}wrapper`)
  const vh = window.innerHeight * 0.01
  const dropdown = find(`.${componentPrefix}dropdown`, el)
  const closeBtn = find(`.${componentPrefix}closeDetails`, el)
  const innerDiv = find(`.${componentPrefix}inner`, el)
  const contentCloseBtn = find('[data-closebtn]', innerDiv)

  // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  // set the value in the --vh custom property to the root of the document
  el.style.setProperty(`--${componentPrefix}Vh`, `${vh}px`)
  dropdown.style.display = 'none'

  const dropdownObserver = new window.IntersectionObserver((entries) => {
    if (!entries[0].isVisible) {
      if (entries[0].intersectionRatio < 1) { // If leaves view
        const dropdownWidth = dropdown.offsetWidth
        const dropdownHeight = dropdown.offsetHeight

        if (entries[0].intersectionRect.width < dropdownWidth) {
          if (entries[0].boundingClientRect.x < 0) {
            dropdown.style.left = '0'
            dropdown.style.right = `-${(opener.offsetWidth * 4.3)}px`
            dropdown.classList.add(`${componentPrefix}fixedPosHorizontalArrowLeft`)
          } else {
            dropdown.style.left = `-${(opener.offsetWidth * 4.3)}px`
            dropdown.classList.add(`${componentPrefix}fixedPosHorizontalArrowRight`)
          }
        }
        if (entries[0].intersectionRect.height < dropdownHeight) {
          let topPosition = dropdown.offsetHeight
          if (dropdown.classList.contains(`${componentPrefix}hasOffset`)) {
            topPosition = dropdown.offsetHeight + 6
          }
          dropdown.style.top = `-${(topPosition)}px`
          dropdown.classList.add(`${componentPrefix}fixedPosArrowVertical`)
        }
      }
      dropdown.classList.add(`${componentPrefix}--open`)
    } else {
      dropdown.classList.remove(`${componentPrefix}--open`)
    }

    dropdownObserver.unobserve(dropdown)
  })

  if (mouseoverinteraction && window.innerWidth > 1023) {
    let timer = null

    opener.addEventListener('mouseenter', () => {
      clearTimeout(timer)
      dropdownObserver.unobserve(dropdown)
      dropdown.removeAttribute('style')
      dropdown.classList.remove(`${componentPrefix}fixedPosArrowVertical`)

      if (otherDropdowns.length) {
        closeOtherDropdowns(dropdown)
      }

      dropdown.style.left = `-${((dropdown.offsetWidth - opener.offsetWidth) / 2)}px`
      dropdownObserver.observe(dropdown)
    })

    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(timer)
    })

    opener.addEventListener('mouseleave', () => {
      timer = setTimeout(() => {
        resetDropDown(dropdown)
      }, 700)
    })

    dropdown.addEventListener('mouseleave', () => {
      resetDropDown(dropdown)
    })
  } else {
    opener.addEventListener('click', (e) => {
      e.stopPropagation()
      dropdownObserver.unobserve(dropdown)
      dropdown.removeAttribute('style')
      dropdown.classList.remove(`${componentPrefix}fixedPosArrowVertical`)

      if (otherDropdowns.length) {
        closeOtherDropdowns(dropdown)
      }

      if (!dropdown.classList.contains(`${componentPrefix}--open`)) {
        document.addEventListener('click', closeDropdown)
        if (window.innerWidth > 1023) {
          dropdown.style.left = `-${((dropdown.offsetWidth - opener.offsetWidth) / 2)}px`
          dropdownObserver.observe(dropdown)
        } else {
          dropdown.classList.add(`${componentPrefix}--open`)
        }
      } else {
        resetDropDown(dropdown)
      }
    })
  }

  closeBtn.addEventListener('click', (e) => {
    resetDropDown(dropdown)
  })

  if (contentCloseBtn) {
    contentCloseBtn.addEventListener('click', () => {
      resetDropDown(dropdown)
    })
  }

  innerDiv.addEventListener('click', (e) => {
    e.stopPropagation()
  })

  const closeOtherDropdowns = (currentDropdown) => {
    otherDropdowns.forEach(otherDropdown => {
      const dropdown = find(`.${componentPrefix}dropdown`, otherDropdown)

      if (currentDropdown === dropdown) {
        return false
      }
      resetDropDown(dropdown)
    })
  }

  const closeDropdown = (e) => {
    if (!e) {
      return false
    }

    if (e.target.parentElement.parentElement === el) {
      return false
    }

    const openDropdown = document.querySelector(`.${componentPrefix}--open`)
    document.removeEventListener('click', closeDropdown)

    if (openDropdown) {
      resetDropDown(openDropdown)
    }
  }

  const resetDropDown = (dropdown) => {
    dropdown.removeAttribute('style')
    dropdown.style.display = 'none'
    dropdown.classList.remove(`${componentPrefix}--open`)
    dropdown.classList.remove(`${componentPrefix}fixedPosArrowVertical`)
    dropdown.classList.remove(`${componentPrefix}fixedPosHorizontalArrowRight`)
    dropdown.classList.remove(`${componentPrefix}fixedPosHorizontalArrowLeft`)
  }
}

register('MiniDropdown', MiniDropdown)
